import { render, staticRenderFns } from "./BaseCardServicesIncludedModal.vue?vue&type=template&id=991ae20e&scoped=true&"
import script from "./BaseCardServicesIncludedModal.vue?vue&type=script&lang=ts&"
export * from "./BaseCardServicesIncludedModal.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCardServicesIncludedModal.vue?vue&type=style&index=0&id=991ae20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991ae20e",
  null
  
)

export default component.exports